import { render, staticRenderFns } from "./OpenFundHeader.vue?vue&type=template&id=71a7ebda&scoped=true&"
import script from "./OpenFundHeader.vue?vue&type=script&lang=js&"
export * from "./OpenFundHeader.vue?vue&type=script&lang=js&"
import style0 from "./OpenFundHeader.vue?vue&type=style&index=0&id=71a7ebda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a7ebda",
  null
  
)

export default component.exports